angular.module('directives.dashboard').directive('wgtInfoTodayOrder', ['DashboardApiService',
        function (DashboardApiService) {
            return {
                templateUrl: 'directives/dashboard/widgets/wgtInfoTodayOrder/wgtInfoTodayOrder.tpl.html',
                link: function ($scope, $element) {
                    $scope.isLoaded = false;
                    $scope.hasError = false;
                    $scope.loadWidget = function () {
                        DashboardApiService.getWidgetData($scope.item.name, $scope.item.setting)
                            .then(function (response) {
                                $scope.widgetData = response.data;
                                $scope.isLoaded = true;
                            }, function (response) {
                                $scope.hasError = true;
                            });
                    };
                    $scope.loadWidget();
                }
            };
        }]
);
